/*
 * @Auther: 罗耀祖
 * @Date: 2021-07-07 19:38:01
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-02-18 11:11:08
 * @name: 路由缓存
 * @Description: 路由缓存
 * @FilePath: \preSaleNafterSaleInside\project\src\store\modules\cashView.js
 * @Author: DESKTOP-1QU67QM
 */

const state = {
    cashRouters: [],
}

const mutations = {
    // 添加缓存路由commit
    ADD_CASHROUTERS(state, name) {
        //判断是否已缓存
        !(state.cashRouters.findIndex(x => x === name) > -1) && (state.cashRouters.push(name));
    },
    // 删除缓存路由commit
    DEL_CASHROUTERS(state, name) {
        const index = state.cashRouters.findIndex(x => x === name);
        index > -1 && state.cashRouters.splice(index, 1);
    },
    // 清空缓存路由commit
    CLEAR_CASHROUTERS(state) {
        state.cashRouters = [];
    }
}

const actions = {
    // 添加缓存路由dispatch
    addCashRouters({ commit,state }, route) {
        const matched = route.matched;
        for (let x in matched) {
            //判断是否需要缓存
            matched[x]?.meta?.keepalive && commit('ADD_CASHROUTERS', matched[x].name);
        }
    },
    // 删除缓存路由dispatch
    delCashRouters({ commit }, route) {
        commit('DEL_CASHROUTERS', route.name);
    },
    // 清空缓存路由dispatch
    clearCashRouters({ commit }) {
        commit('CLEAR_CASHROUTERS');
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}